import { useState, useEffect } from 'react';
import { Monitor, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobileDevice } from '@/hooks/use-mobile';

const MOBILE_BANNER_DISMISSED_KEY = 'radius_mobile_banner_dismissed';

export function MobileWarningBanner() {
  const isMobileDevice = useIsMobileDevice();
  const [isDismissed, setIsDismissed] = useState(true); // Start dismissed to prevent flash

  useEffect(() => {
    // Check localStorage on mount
    const dismissed = sessionStorage.getItem(MOBILE_BANNER_DISMISSED_KEY);
    setIsDismissed(dismissed === 'true');
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem(MOBILE_BANNER_DISMISSED_KEY, 'true');
    setIsDismissed(true);
  };

  // Don't render if not on mobile device or if dismissed
  if (!isMobileDevice || isDismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-amber-50 dark:bg-amber-950 border-t border-amber-200 dark:border-amber-800 p-3 shadow-lg">
      <div className="flex items-center justify-between gap-3 max-w-md mx-auto">
        <div className="flex items-center gap-2 text-amber-800 dark:text-amber-200">
          <Monitor className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            For the best experience, please use a desktop browser
          </p>
        </div>
        <Button
          variant="ghost"
          size="icon"
          className="h-8 w-8 flex-shrink-0 text-amber-800 dark:text-amber-200 hover:bg-amber-100 dark:hover:bg-amber-900"
          onClick={handleDismiss}
          aria-label="Dismiss mobile warning"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
